import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-3">
            真实反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            来看看其他漫画爱好者都在读什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 md:p-7"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="pt-4 border-t border-background-200">
                <span className="inline-flex items-center gap-1 text-xs text-primary-600">
                  <i className="ri-bookmark-line"></i>
                  {item.work}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}